<template>
  <div class="download">
    <img src="https://img.stem.cn/online/download_app/stem.png" class="stem">

    <a style="display: block;"  href="http://ol.cdn.stem.cn/apk/sharkpark_19080201.apk" v-show="show">
       <img src="https://img.stem.cn/online/download_app/Android.png" class="android">
    </a>
    <div @click="open" v-show="!show">
      <img src="https://img.stem.cn/online/download_app/Android.png" class="android">
    </div>
    <a style="display: block;"  href="https://apps.apple.com/cn/app/id1473551486?mt=8" >
      <img src="https://img.stem.cn/online/download_app/iphone.png" class="iphone">
    </a>
    <img src="https://img.stem.cn/online/download_app/log.png" class="log">
    <div class="mask" v-show="mask">
      <img src="https://img.stem.cn/online/download_app/mask.png">
    </div>
  </div>
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'download',
  data(){
    return {
     show:true,
     mask:false,
    }
  },
  components: {
    // HelloWorld  
  },
  
  methods:{
   open(){
    this.mask = true;
   }
  },

  created(){
    // 判断运行环境
    let ua = window.navigator.userAgent;
    if (ua.match(/MicroMessenger/i) == 'MicroMessenger') {
        // 微信浏览器 
        this.show = false;
    }
  }

}
</script>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw
}
.download {
  width: 100vw;
  height:100vh;
  box-sizing: border-box;
  background-color: #007cf1;
  padding-top:vw(165);
  text-align: center;
  .stem {
    width: vw(551);
  }
  .android {
    width: vw(494);
    margin-top:vw(35);
    margin-bottom:vw(40)
  }
  .iphone {
    width: vw(494);
  }
  .log {
    width: vw(233);
    margin-top: vw(100)
  }
  .mask {
   opacity:0.9;
   -moz-opacity:0.9;
   filter:alpha(opacity=90);
   position: absolute;
   background-color: black;
   z-index:10;
   top: 0;
   left: 0;
   width:100vw;
   height:100vh;
   img {
    width: vw(577);
    margin-top:vw(75);
   }
  }
}
</style>
